// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3miZ8","tab":"ProcedureTabs_tab__1JuIy"};